import { render, staticRenderFns } from "./SchoolOffers.vue?vue&type=template&id=5ffa0ff7&"
import script from "./SchoolOffers.vue?vue&type=script&lang=js&"
export * from "./SchoolOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports